module.exports = "/_next/static/images/union-pay-35b08be11ddba3e884b4d1139b429596.svg";